import React from 'react';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';

import { CardContainer, DiskBadgeWrapper } from '../styles';

export const UnlimitedFeeFreeTransfersCard = (props) => {
    const hasTransfersInfo = props.dashboard?.countOfTransfers > 0;
    return (
        <CardContainer onClick={!props.isBlocked ? props.onCardClick : null} $isHoverable={!props.isBlocked}>
            <Row indent={hasTransfersInfo ? '24px' : '0'} flex>
                <DiskBadgeWrapper>
                    <DiskBadge variant="primary" iconName="transfers" diskSize="fixed-small" isDisabled={props.isBlocked} />
                </DiskBadgeWrapper>
                <div>
                    <Text variant="div" indent="4px" color={props.isBlocked ? 'secondary' : 'primary'}>
                        {props.plusMainTransfers}
                    </Text>
                    <Text variant="div" size="secondary" color={props.isBlocked ? 'error' : 'secondary'}>
                        {props.subscriptionStatus}
                    </Text>
                </div>
            </Row>
            {hasTransfersInfo && (
                <>
                    <Text variant="div" indent="8px" color={props.isBlocked ? 'secondary' : 'primary'}>
                        {props.subscriptionStartDate}
                    </Text>
                    <Row flex justify="between">
                        <Text size="secondary" color="secondary">
                            {`${props.plusTransferCount} ${props.dashboard?.countOfTransfers}`}
                        </Text>
                        <Text size="secondary" color="secondary">
                            {`${props.plusMoneySaved} ${props.dashboard?.savedFees}`}
                            <Text size="secondary" color="secondary" smallCaps leftSpacer>
                                {props.subscriptionCurrencyCode}
                            </Text>
                        </Text>
                    </Row>
                </>
            )}
        </CardContainer>
    );
};
